import {
  type FetchOnboardingStepsResponse,
  fetchOnboardingSteps,
} from '@otter-ai/recall-client';
import { APP_ID } from '@/constants/constant';
import type {
  NEW_ONBOARDING_FLOW,
  NEW_ONBOARDING_STEP,
} from '@/shared/types/welcome';
import type { AdditionalQueryOptions } from '@/shared/utils/queryCreators';

const fetchOnboardingStepsQueryKey = ['fetch_onboarding_steps'] as const;
type FetchOnboardingStepsQueryKey = typeof fetchOnboardingStepsQueryKey;

type AdditionalFetchOnboardingStepsQueryOptions = AdditionalQueryOptions<
  FetchOnboardingStepsResponse,
  FetchOnboardingStepsQueryKey
>;

export type FetchOnboardingStepsQuery = {
  readonly queryKey: typeof fetchOnboardingStepsQueryKey;
  readonly queryFn: () => Promise<FetchOnboardingStepsResponse>;
} & AdditionalFetchOnboardingStepsQueryOptions;

export function fetchOnboardingStepsQueryCreator({
  flow_name,
  last_completed_step,
  additionalOptions,
}: {
  flow_name: NEW_ONBOARDING_FLOW;
  last_completed_step?: NEW_ONBOARDING_STEP;
  additionalOptions?: AdditionalFetchOnboardingStepsQueryOptions;
}): FetchOnboardingStepsQuery {
  return {
    queryKey: fetchOnboardingStepsQueryKey,
    queryFn: async () => {
      const query = {
        appid: APP_ID,
        flow_name,
        last_completed_step,
      };

      const response = await fetchOnboardingSteps({
        query,
        throwOnError: true,
      });

      return response.data;
    },
    ...additionalOptions,
  };
}
